/**
 * Created by Andrey Popov on 24.03.21
 */

cleverapps.setRestDummies = function (enabled) {
    const dummifyFunc = function (ClassObj, funcName, dummyFunc) {
        if (ClassObj.prototype && ClassObj.prototype[funcName]) {
            ClassObj.prototype[`super_${funcName}`] = ClassObj.prototype[funcName];
            ClassObj.prototype[funcName] = dummyFunc;
        } else if (ClassObj[funcName]) {
            ClassObj[`super_${funcName}`] = ClassObj[funcName];
            ClassObj[funcName] = dummyFunc;
        }
    };
    const restoreFunc = function (ClassObj, funcName) {
        if (ClassObj.prototype && ClassObj.prototype[`super_${funcName}`]) {
            ClassObj.prototype[funcName] = ClassObj.prototype[`super_${funcName}`];
            delete ClassObj.prototype[`super_${funcName}`];
        } else if (ClassObj[`super_${funcName}`]) {
            ClassObj[funcName] = ClassObj[`super_${funcName}`];
            delete ClassObj[`super_${funcName}`];
        }
    };

    if (enabled) {
        dummifyFunc(connector.payments, "getSubscriptionStatus", (options, callback) => {
            callback();
        });
        if (typeof UserClan !== "undefined") {
            dummifyFunc(UserClan, "loadRequest", (onSuccess) => {
                onSuccess(cleverapps.loadedSnapshot && cleverapps.loadedSnapshot.clan);
            });
            dummifyFunc(ClanMessages, "loadMessagesRequest", (onSuccess) => {
                onSuccess(cleverapps.loadedSnapshot && cleverapps.loadedSnapshot.clan);
            });
        }
        if (typeof KnockoutGame !== "undefined") {
            dummifyFunc(KnockoutGame, "checkConnection", (f) => {
                f();
            });
        }
    } else {
        restoreFunc(connector.payments, "getSubscriptionStatus");
        if (typeof UserClan !== "undefined") {
            restoreFunc(UserClan, "loadRequest");
            restoreFunc(ClanMessages, "loadMessagesRequest");
        }
        if (typeof KnockoutGame !== "undefined") {
            restoreFunc(KnockoutGame, "checkConnection");
        }
    }
};

cleverapps.getSnapshotIdFromUrl = function () {
    let snapshotId = window.location.pathname.substring(1);

    if (/^[0-9a-z]*$/.test(snapshotId) === false) {
        snapshotId = undefined;
    }

    if (window.location.hash) {
        const params = cleverapps.getRequestParameters(window.location.hash, true);
        snapshotId = params.snapshot;
    }

    if (!snapshotId && window.location.search) {
        const params = cleverapps.getRequestParameters(window.location.search);
        snapshotId = params.snapshot;
    }

    return snapshotId;
};

cleverapps.importSnapshot = function () {
    if (connector.platform.oneOf(connector.WECHAT)) {
        return;
    }

    const snapshotId = cleverapps.getSnapshotIdFromUrl();

    if (!snapshotId || !cleverapps.config.debugMode) {
        return;
    }

    cleverapps.snapshotToLoad = snapshotId;

    cleverapps.config.importMode = true;
    cleverapps.setRestDummies(true);

    // for TestSocial
    const onUpdateSocial = function () {
        if (connector.social.getStatus() === connector.STATUS_DISABLED) {
            return;
        }

        connector.social.getPlugin().updateSession = function (id) {
            this.id = id;
            this.token = "123";
        };
        connector.social.getPlugin().removeSession = function () {
            this.id = undefined;
            this.token = undefined;
            this.expires = undefined;
        };
        connector.social.getPlugin().loadSession = function () {};
    };

    connector.social.on("pluginChanged", onUpdateSocial);
    onUpdateSocial();

    connector.dataLoader.setEnabled(false);
    cleverapps.dataLoader.setEnabled(false);
};

cleverapps.loadSnapshot = function (snapshotId, callback) {
    console.log("loading snapshot start");

    let snapshot;

    new ActionPlayer([
        function (f) {
            const onLoad = (loadedSnapshot) => {
                snapshot = loadedSnapshot;
                f();
            };

            if (snapshotId.indexOf("/") !== -1) {
                cleverapps.snapshots.getSnapshotFromUrl(`https://${snapshotId}`, onLoad);
            } else {
                cleverapps.snapshots.getSnapshot(snapshotId, onLoad);
            }
        },

        function (f) {
            if (snapshot) {
                console.log("loading snapshot finished", snapshot.users);

                // original snapshot returned from player - importData will change the loadedSnapshot further
                cleverapps.originalSnapshot = cleverapps.clone(snapshot, true);

                snapshot = cleverapps.snapshots._migrateSnapshot(snapshot);

                cleverapps.loadedSnapshot = snapshot;
                cleverapps.loadedSnapshot.snapshotId = snapshotId;

                cleverapps.snapshots.importData(snapshot, f);

                if (cleverapps.playButton) {
                    cleverapps.playButton.update();
                }
            } else {
                alert(`Snapshot failed to load: ${snapshotId}\n\nThe game will now open WITHOUT snapshot data - this is NOT the player's state!`);
                f();
            }
        },

        function (f) {
            connector.synchronizer.trigger("complete");
            f();
        }
    ]).play(callback);

    cleverapps.flags.norest = true;
    cleverapps.flags.nologin = false;
    connector.synchronizer.disable();
};

cleverapps.reloadSnapshotScene = function (scene, f) {
    // old snapshots store an episode number as scene.location - see Snapshots._migrateSnapshot
    if (cleverapps.meta.locations[scene.location]) {
        cleverapps.meta.switchLocation(scene.location);
    }

    if (cleverapps.meta.getLocationMeta(scene.location).locationType === "merge") {
        cleverapps.meta.gotoLocationScene(f);
        return;
    }

    const level = new Level(scene.episodeNo, scene.levelNo, { type: scene.levelType });

    if (cleverapps.knockoutGame && !level.isDailyCup()) {
        cleverapps.knockoutGame.rumble = new Rumble();
        cleverapps.knockoutGame.rumble.whenInitialize(() => {
            level.play(f);
        });
        return;
    }

    level.play(f);
};
